import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

// Match the Help page layout structure
export const VideoPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getVideoWidth = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "920px";
  }
  if (deviceType === "tablet") {
    return "570px";
  }
  return "360px";
};

const getVideoPadding = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "90px 142px 142px 142px";
  }
  if (deviceType === "tablet") {
    return "60px 18px 112px 18px";
  }
  return "40px 0px 92px 0px";
};

export const VideoPageComponentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-columns: ${({ deviceType }) => getVideoWidth(deviceType)};
  padding: ${({ deviceType }) => getVideoPadding(deviceType)};
`;

export const VideoPageComponentGrid = styled.div<{
  deviceType: DeviceType;
}>`
  display: ${({ deviceType }) => (deviceType === "mobile" ? "" : "grid")};
  grid-template-rows: auto 40px auto;
  gap: 0;
`;

export const VideoGeneralContainer = styled.div<{ padding?: string }>`
  margin-bottom: 24px;
  padding: ${({ padding }) => padding || "0px"};
  max-width: 920px;
  display: flex;
  justify-content: center;
`;

export const VideoPageBackTo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 0;
  width: fit-content;
  align-self: start;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const VideoTitle = styled.div`
  align-self: stretch;
  color: #636467;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  word-wrap: break-word;
  padding-left: 16px;
  margin-top: 14px;
`;

export const VideoDescription = styled.div`
  align-self: stretch;
  color: #636467;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  margin-top: 20px;
  margin-bottom: 24px;
  max-width: 600px;
`;
